import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "iconProps", "color", "classes", "shape", "size", "iconColor", "backgroundColor"];
import React from 'react';
import classnames from 'classnames/bind';
import { cssUtils } from "../internal/CssUtils";
import styles from './ColorIcon.css';
var cx = classnames.bind(styles);
var defaultIconProps = {};
var defaultClasses = {};
var sizesMap = {
  s: 16,
  m: 20,
  l: 32
};
export var ColorIcon = function ColorIcon(_ref) {
  var IconComponent = _ref.icon,
      _ref$iconProps = _ref.iconProps,
      iconProps = _ref$iconProps === void 0 ? defaultIconProps : _ref$iconProps,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'mono' : _ref$color,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultClasses : _ref$classes,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'circle' : _ref$shape,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      iconColor = _ref.iconColor,
      backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, _excluded);

  var iconSize = sizesMap[size];
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx(classes.root, 'root', "".concat(iconColor ? cssUtils("color_".concat(iconColor)) : "color_".concat(color)), "".concat(backgroundColor && cssUtils("backgroundColor_".concat(backgroundColor))), "shape_".concat(shape), "size_".concat(size))
  }), IconComponent &&
  /*#__PURE__*/
  // спред пропсов в конце, чтобы можно было задать кастомный размер иконки
  React.createElement(IconComponent, _extends({
    height: iconSize,
    width: iconSize
  }, iconProps)));
};